import { createAction } from "redux-act";

// Detail
export const MEMActiDetail = createAction("MEM_ACTIDETAIL");